import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const KEY = "produlimp_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((p) => p.id === product.id);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + qty };
        return copy;
      }
      return [...prev, { id: product.id, code: product.sku || product.id.slice(0, 6).toUpperCase(), name: product.name, description: product.description || "", price: product.price, image: product.image, quantity: qty }];
    });
    toast.success(`${product.name} agregado al carrito`);
  };

  const updateQty = (id, qty) => {
    if (qty <= 0) return removeItem(id);
    setItems((prev) => prev.map((p) => (p.id === id ? { ...p, quantity: qty } : p)));
  };

  const removeItem = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
  const clear = () => setItems([]);

  const addMany = (entries) => {
    setItems((prev) => {
      const copy = [...prev];
      entries.forEach(({ product, quantity }) => {
        const idx = copy.findIndex((p) => p.id === product.id);
        if (idx >= 0) copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        else copy.push({ id: product.id, code: product.sku || product.id.slice(0, 6).toUpperCase(), name: product.name, description: product.description || "", price: product.price, image: product.image, quantity });
      });
      return copy;
    });
  };

  const total = items.reduce((sum, it) => sum + it.price * it.quantity, 0);
  const count = items.reduce((sum, it) => sum + it.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, addMany, updateQty, removeItem, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
